export default __webpack_public_path__ + "static/media/142.16a4bbe3.gif";